import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-229eab8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "sidebar-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "circle", -1))
const _hoisted_4 = {
  key: 0,
  class: "sidebar-links"
}
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar", { show: _ctx.showSidebar }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createElementBlock("section", {
        class: _normalizeClass(["sidebar-section", { open: _ctx.route.path.indexOf(item.link) > -1 }]),
        key: i
      }, [
        _createElementVNode("a", {
          onClick: () => _ctx.goTo(item.link)
        }, [
          _createElementVNode("h1", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(item.title), 1)
          ])
        ], 8, _hoisted_1),
        (_ctx.route.path.indexOf(item.link) > -1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, j) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: j,
                  class: _normalizeClass({ active: _ctx.route.path.indexOf(child.link) > -1 })
                }, [
                  _createElementVNode("a", {
                    onClick: () => _ctx.goTo(child.link)
                  }, _toDisplayString(child.title), 9, _hoisted_5)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 2))
}